'use strict';

const ManagerFlowTokenV3 = require('../HomeyAPIV3/ManagerFlowToken');
const FlowToken = require('./ManagerFlowToken/FlowToken');

class ManagerFlowToken extends ManagerFlowTokenV3 {

  static CRUD = {
    ...super.CRUD,
    FlowToken,
  };

  async getFlowToken({
    $cache = true,
    id,
  }) {
    if ($cache === true && this.__cache['flowtoken'][id]) {
      return this.__cache['flowtoken'][id];
    }

    return this.__super__getFlowToken({
      id: id.split(':').reverse()[0],
      uri: id.split(':', 3).join(':'),
    });
  }

}

module.exports = ManagerFlowToken;
